// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServicesMain from "./ServiceMain";
import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ServerError from "../Error/ServerError";

// CONFIGURAZIONI
import { appConfig, AGENCY_ID } from "../../config/appConfig";

const Services: React.FC = () => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(AGENCY_ID);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>

            <Helmet>
                <title>{t('navigation.servicesLinkTitle')} | {agency?.agencyName ?? t('common.defaultAgencyName')}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.pageTitle')} isSeo={true}/>

            <div id="page" className="page-services">
                <section className="space-ptb">
                    <div className="container">
                        <div className="row align-items-start">
                            <div className="col-12 col-lg-8 col-xl-9">
                                <ServicesMain />
                            </div>
                            {/* Colonna Sidebar (Widgets) */}
                            <div id="sidebar" className="col-12 col-lg-4 col-xl-3">

                                <WidgetContacts
                                    agencyDataAddress={agency?.address_details?.address ?? ''}
                                    agencyDataCity={agency?.address_details?.city_name ?? ''}
                                    agencyDataComuneCapoluogo={agency?.address_details?.city_name === agency?.address_details?.province_name}
                                    agencyDataProvinciaSigla={agency?.address_details?.sigla ?? ''}
                                    agencyDataEmail={appConfig.agency.agencyEmail}
                                    agencyDataEmailShow={appConfig.ui.agencyWidget.showEmail}
                                    agencyDataPhone1={agency?.phone1 ?? ''}
                                    agencyDataPhone2={agency?.phone2 ?? ''}
                                    agencyDataInternationalPrefix={appConfig.agency.intlPrefix ?? '+39'}
                                    agencyDataMobile={agency?.mobile ?? ''}
                                    agencyDataMobile2={agency?.mobile2 ?? ''}
                                    agencyDataFax={agency?.fax ?? ''}
                                    agencySocialShow={appConfig.ui.agencyWidget.showSocialLinks}
                                    agencyDataWhatsapp={appConfig.socialLinks.whatsapp}
                                    agencyDataFacebook={appConfig.socialLinks.facebook}
                                    agencyDataInstagram={appConfig.socialLinks.instagram}
                                    agencyDataTwitter={appConfig.socialLinks.twitter}
                                    agencyDataLinkedin={appConfig.socialLinks.linkedin}
                                    agencyDataPinterest={appConfig.socialLinks.pinterest}
                                    agencyDataYoutube={appConfig.socialLinks.youtube}
                                />

                                <WidgetPartners partners={appConfig.content.partners} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Services;